import { Dialog, Box, IconButton, Typography, Button } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useRouter } from '../hooks/useRouter'
import { memo } from 'react'

interface VipDialogProps {
  open: boolean
  onClose: () => void
  showUpgradeButton?: boolean
}

const VipDialog = memo(({ open, onClose, showUpgradeButton = true }: VipDialogProps) => {
  const router = useRouter()

  const handleUpgrade = () => {
    onClose()
    router.push('/code')
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <Box sx={{ width: '300px', minHeight: '150px', p: 2 }}>
        <Box display="flex" justifyContent="flex-end">
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={{ mt: 2, mb: 2, textAlign: 'center' }}>
          <Typography fontSize="18px" fontWeight="bold" gutterBottom>
            เฉพาะสมาชิก VIP เท่านั้น
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            กรุณาเติมวันใช้งานเพื่อเข้าถึงฟีเจอร์นี้
          </Typography>
        </Box>
        {showUpgradeButton && (
          <Box display="flex" justifyContent="center" sx={{ mt: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleUpgrade}
              sx={{ borderRadius: 10, px: 4 }}
            >
              เติมวันใช้งาน
            </Button>
          </Box>
        )}
      </Box>
    </Dialog>
  )
})

VipDialog.displayName = 'VipDialog'

export default VipDialog
